// extracted by mini-css-extract-plugin
module.exports = {"mainJuzgado":"JuzgadoPoliciaLocal_mainJuzgado__1AVLr"};